import React, {useEffect, useState} from 'react';
import {Form, Grid, Header, Segment, Table} from 'semantic-ui-react';
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {ToasterConfig} from "../../../../config/ToasterConfig";
import useBusinessUnitService from 'services/backoffice/hooks/useBusinessUnitService';
import {CreateBusinessUnitRequest} from 'models/requests/create-business-unit-request';
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import {ShortDto} from "../../../../models/short-dto";

const CreateBusinessUnitPage = () => {
    const [businessUnit, setBusinessUnit] = useState<Partial<CreateBusinessUnitRequest>>({});
    const navigate = useNavigate();
    const [clientes, setClients] = useState<ShortDto[]>([])
    const {createBusinessUnit} = useBusinessUnitService();
    const {getAllClientsShortDto} = useClientService();

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setBusinessUnit((prevBusinessUnit) => ({
            ...prevBusinessUnit,
            [name]: value,
        }));
    };

    useEffect(() => {
        function ListClientes() {
            getAllClientsShortDto().then((response) => {
                setClients(response);
            })
                .catch(error => {
                })
        }

        ListClientes()
    }, [])


    const handleSubmit = async () => {
        try {
            await createBusinessUnit(businessUnit)
            navigate('/backoffice/business-units/')
            toast.success('Unidade de negócio criada com sucesso', ToasterConfig.success);
        } catch (error) {
        }
    };

    return (
        <div>
            <Grid.Column mobile={16} tablet={8} computer={6}>
                <Header as="h3" textAlign="center" color={'green'}>
                    Unidades de Negócio / Adicionar
                </Header>
                <Segment>
                    <Form onSubmit={handleSubmit}>

                        <Form.Input
                            label="Nome"
                            name="name"
                            type="text"
                            placeholder="Nome da Unidade de Negócios"
                            value={businessUnit.name}
                            onChange={handleInputChange}
                            required
                        />

                        <Form.Input
                            label="Descrição"
                            name="description"
                            type="text"
                            placeholder="Descrição da Unidade de Negócios"
                            value={businessUnit.description}
                            onChange={handleInputChange}
                        />

                        <Form.Select
                            label={'Cliente ao qual a unidade de negócio pertence'}
                            options={clientes}
                            placeholder='Selecione uma opção'
                            value={businessUnit?.clientId || ''}
                            required
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setBusinessUnit(prevUnit => ({...prevUnit, clientId: selectedValue}));
                            }}
                        />


                        <Table.Row>
                            <Table.HeaderCell>
                                <Form.Button content="Voltar"
                                             icon='arrow left'
                                             onClick={() => navigate('/backoffice/business-units/')} grey/>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Form.Button content="Adicionar"
                                             type={"submit"}
                                             icon='save'
                                             color={"green"}/>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Form>
                </Segment>
            </Grid.Column>
        </div>
    );
};

export default CreateBusinessUnitPage;
